import { Routes } from 'config/routes';
import CardTabs, { ITabsItem } from 'modules/common/components/CardTabs';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  RecruiterDashboardProvider,
  useRecruiterDashboard,
} from '../../contexts/RecruiterDashboardContext';
import { TabLinkProvider } from '../../contexts/TabLinkContext';
import RecruiterDashboardContent from '../RecruiterDashboardContent';
import RecruiterDonorDetails from '../RecruiterDonorDetails';
import RecruiterLeaderboardTab from '../RecruiterLeaderboardTab';

/** Inner component that uses the context to attach the ref */
const RecruiterDashboardTabsInner: FC = () => {
  const { t } = useTranslation('dashboard.RecruiterDashboard');
  const { contentRef, lastDonorDetailsUrl } = useRecruiterDashboard();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(location.pathname);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  const onChangeTabs = (tabKey: string) => {
    if (
      tabKey === Routes.DashboardsRecruiterDonorDetails &&
      lastDonorDetailsUrl
    ) {
      navigate(lastDonorDetailsUrl);
    } else {
      navigate(tabKey);
    }
  };

  const recruiterCardTabs: ITabsItem[] = useMemo(() => {
    return [
      {
        title: t('tabDashboard'),
        content: <RecruiterDashboardContent />,
        key: Routes.DashboardsRecruiterDashboard,
      },
      {
        title: t('tabDonorDetails'),
        content: <RecruiterDonorDetails />,
        key: Routes.DashboardsRecruiterDonorDetails,
      },
      {
        title: t('tabLeaderboard'),
        content: <RecruiterLeaderboardTab />,
        key: Routes.DashboardsRecruiterLeaderboard,
      },
    ];
  }, [t]);

  return (
    <div ref={contentRef} style={{ width: '100%' }}>
      <CardTabs
        onChange={onChangeTabs}
        activeKey={activeTab}
        items={recruiterCardTabs}
      />
    </div>
  );
};

const RecruiterDashboardTabs: FC = () => {
  return (
    <RecruiterDashboardProvider>
      <TabLinkProvider>
        <RecruiterDashboardTabsInner />
      </TabLinkProvider>
    </RecruiterDashboardProvider>
  );
};

export default RecruiterDashboardTabs;
